<template>
  <div class="user_head">
    <div class="user_head_left">
      <el-avatar icon="el-icon-user-solid" class="user_head_logo"/>
    </div>
    <div class="user_head_mid">
      <div class="user_head_name">
        {{ user.phone || user.email }}
      </div>
      <div class="user_head_role">
        {{role.role_name}}
      </div>
    </div>
  </div>
</template>

<script>
  import { getJsonStorage } from "../../util/storage";

  export default {
    name: "UserHead",
    components:{

    },
    data() {
      return {
        user: getJsonStorage('openai_user'),
        privileges:{},
        role:{}
      }
    },
    mounted(){
      let privileges = getJsonStorage('openai_privileges');
      this.privileges = privileges;
      this.role = privileges.role;
    },
    methods: {
      toUserDetail(){
        this.$router.push('/user/detail');
      }
    }
  }
</script>

<style scoped>
  .user_head {
    width: 100%;
    height:10vh;
    line-height:10vh;
    text-align:center;
    top:6vh;
  }
  .user_head_left {
    width:20%;
    float:left;
    height:10vh;
    line-height:10vh;
    text-align:center;
  }
  .user_head_mid {
    width:65%;
    float:left;
    height:10vh;
    line-height:10vh;
    text-align:center;
  }
  .user_head_right {
    width:10%;
    padding-right:5%;
    float:left;
    height:10vh;
    line-height:10vh;
    text-align:right;
    font-weight:bold;
    color:grey;
  }
  .user_head_logo {
    margin-top:2vh;
  }
  .user_head_name {
    width:100%;
    height:4vh;
    line-height:7vh;
    float:left;
    font-size:.85rem;
    text-align:left;
  }
  .user_head_role {
    width:100%;
    height:6vh;
    line-height:6vh;
    float:left;
    font-size:.75rem;
    text-align:left;
    color:grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/head.vue